/* wrapt-reviews.js -- the two review components that are written into the page
   (D150; styles in wrapt-reviews.css). The reviews are already in the HTML;
   this only adds:
   - the grid's "Show more", which shows the next row set of cards;
   - the snippet's arrows and its turn every few seconds (paused on hover,
     focus or touch, and off for reduced motion). */
(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-wr-grid]').forEach((grid) => {
    const more = grid.querySelector('[data-wr-more]');
    if (!more) return;
    const step = Number(grid.dataset.wrStep) || 8;
    more.addEventListener('click', () => {
      const next = [...grid.querySelectorAll('.wr-card[hidden]')].slice(0, step);
      next.forEach((card) => { card.hidden = false; });
      if (!grid.querySelector('.wr-card[hidden]')) more.closest('.wr-grid__more').hidden = true;
      if (next[0]) next[0].focus({ preventScroll: true });
    });
  });

  document.querySelectorAll('[data-wr-snip]').forEach((snip) => {
    const vp = snip.querySelector('[data-wr-vp]');
    const cards = [...snip.querySelectorAll('.wr-snip__card')];
    if (!vp || cards.length < 2) {
      snip.querySelectorAll('.wr-snip__arrow').forEach((b) => { b.hidden = true; });
      return;
    }
    const current = () => {
      const mid = vp.scrollLeft + vp.clientWidth / 2;
      let best = 0;
      cards.forEach((c, i) => {
        if (Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) < Math.abs(cards[best].offsetLeft + cards[best].offsetWidth / 2 - mid)) best = i;
      });
      return best;
    };
    const go = (i) => {
      const n = (i + cards.length) % cards.length;
      const c = cards[n];
      vp.scrollTo({ left: c.offsetLeft - (vp.clientWidth - c.offsetWidth) / 2, behavior: reduced() ? 'auto' : 'smooth' });
    };
    snip.querySelector('[data-wr-prev]').addEventListener('click', () => go(current() - 1));
    snip.querySelector('[data-wr-next]').addEventListener('click', () => go(current() + 1));

    const secs = Number(snip.dataset.autoplay) || 0;
    if (!secs || reduced()) return;
    let paused = false;
    let timer = 0;
    const tick = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!paused && !document.hidden) go(current() + 1);
        tick();
      }, secs * 1000);
    };
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    snip.addEventListener('mouseenter', pause);
    snip.addEventListener('mouseleave', resume);
    snip.addEventListener('focusin', pause);
    snip.addEventListener('focusout', resume);
    snip.addEventListener('touchstart', pause, { passive: true });
    tick();
  });
})();
